import { EVENT_TYPES } from "@mmm/contracts";
import { EVENT_TYPE_COLORS, EVENT_TYPE_LABEL_KEYS } from "../../constants.js";
import { ColorDot, useT } from "@mmm/ui";
export function EventTypeLegend() {
  const t = useT();

  return (
    <div className="mmm-event-type-legend">
      {EVENT_TYPES.map((type) => (
        <span key={type}>
          <ColorDot color={EVENT_TYPE_COLORS[type].text} />
          {t(EVENT_TYPE_LABEL_KEYS[type])}
        </span>
      ))}
    </div>
  );
}
